import React, { Component } from 'react';
import ReactTable from 'react-table';
import 'react-table/react-table.css';
import Loader from './nav/Loader';

import { connect } from "react-redux";
import { getLineupFreqData } from "../actions/action_lineupfreq";

class LineupFreq extends Component {
  constructor(props) {
      let columns = [
        { Header: 'First', accessor: 'first_name'},
        {Header: 'Last', accessor: 'last_name'},
      ];
      super(props);
      this.state = {
        cols: columns
      };
      this.defaultSortMethod = this.defaultSortMethod.bind(this);
      this.getTable = this.getTable.bind(this);
  }
  componentDidMount() {
    this.props.getLineupFreqData({
      "year": this.props.yearFilter,
      "team": this.props.teamFilter,
    });
  }
  componentDidUpdate(prevProps){
    var dark = document.body.classList.contains('dark-theme');
    if(prevProps.yearFilter !== this.props.yearFilter || prevProps.teamFilter !== this.props.teamFilter) {
      this.props.getLineupFreqData({
        "year": this.props.yearFilter,
        "team": this.props.teamFilter
      });
    }
    if(prevProps.data !== this.props.data){
      var c = [{Header: 'First', accessor: 'first_name', Cell: props => <a href={'/results/teamsGA/gymnast/'+this.props.yearFilter+'/'+this.props.teamFilter+'/'+props.original.id}>{props.value}</a>},
      {Header: 'Last', accessor: 'last_name', Cell: props => <a href={'/results/teamsGA/gymnast/'+this.props.yearFilter+'/'+this.props.teamFilter+'/'+props.original.id}>{props.value}</a>},];

      if(this.props.data[0] !== undefined && this.props.data[0].meets !== undefined){
        var counter = 1;
        this.props.data[0].meets.forEach(function(element) {
          c.push({Header: String(counter), accessor: `meets.${counter-1}`, Cell: props => <div></div>, width: 50,getProps: (state, rowInfo, column) => {
            if(dark){
              return {
                style: {
                  background: rowInfo.row[column.id] === 1 ? 'rgba(29,161,242,0.75)' : 'rgba(255,171,64,0.75)',
                  borderColor: 'rgba(100,100,100,1)'
                },
                className : 'rowser'
              }
            } else {
              return {
                style: {
                  background: rowInfo.row[column.id] === 1 ? 'rgba(6, 190, 189, 1)' : 'rgba(246, 142, 86, 1)',
                  borderColor: 'white'
                },
                className : 'rowser'
              }
            }
          }});
            counter++;
        });
      }
      this.setState({
        cols: c
      });
    }
  }
  defaultSortMethod(a, b) { //desc
    // force null and undefined to the bottom
    a = (a === null || a === undefined) ? -Infinity : a
    b = (b === null || b === undefined) ? -Infinity : b
    // force any string values to lowercase
    a = a === 'string' ? a.toLowerCase() : a
    b = b === 'string' ? b.toLowerCase() : b

    // Return either 1 or -1 to indicate a sort priority
    if (a > b) {
      return -1
    }
    if (a < b) {
      return 1
    }
    // returning 0, undefined or any falsey value will use subsequent sorts or the index as a tiebreaker
    return 0
  }
  getTable() {
    if(this.props.teamFilter > 0 && this.props.numRows > 0) {
      if(this.props.data[0].meets !== undefined){
        return <div className="row">
            <div className="small-12 columns">
            <div className="row">
                <div className="small-12 columns">
                  <div className="bluebox"></div><div className="bluebox-legend">YES</div>
                  <div className="redbox"></div><div className="bluebox-legend">NO</div>
                </div>
            </div>
            <ReactTable
              className="-striped -highlight"
              data={this.props.data}
              columns={this.state.cols}
              defaultSortMethod={this.defaultSortMethod}
              showPagination={false}
              defaultPageSize={this.props.numRows}
              pageSize={this.props.numRows}
            /><br />
            <p className="note">*Shows the frequency a gymnast competed during a particular year. Meets are numbered in the order they occurred during season. To see which events a gymnast competed in, click on the gymnast&apos;s name.</p>
            </div>
        </div>;
      } else {
        return <div>No meets for this year</div>
      }
    } else {
      return <div>Please Pick a Team</div>
    }
  }
  render() {
    if(!this.props.showLoader){
      return (
        <div>
          {this.getTable()}
        </div>
      );
    } else {
      return <Loader />
    }
  }
}

function mapStateToProps(state) {
  return {
    teamFilter: state.main.teamFilter,
    yearFilter: state.main.yearFilter,
    data: state.lineupFreq.data,
    cols: state.lineupFreq.cols,
    numRows: state.lineupFreq.numRows,
    showLoader: state.lineupFreq.showLoader
  };
}

export default connect(mapStateToProps, { getLineupFreqData })(LineupFreq);
